import React, { useEffect, useState } from 'react';
import Card from './Card';

const TopProject = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const [projects, setProjects] = useState([]);

  useEffect(() => {
          const fetchProjects = async () => {
              try {
                  const res = await fetch('https://website-backend-production-2163.up.railway.app/api/projects'); // Adjust this URL to match your backend
                  const data = await res.json();
                  setProjects(data.reverse());
              } catch (err) {
                  console.error('Failed to fetch projects:', err);
              }
          };
  
          fetchProjects();
      }, []);

  const filteredProjects = projects.filter(projects =>
    projects.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='top-project'>
      <input 
        type="text" 
        placeholder="Search projects..." 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
        className="search-bar"
      />
      <div className='card-container'>
        {filteredProjects.map((projects, index) => (
          <Card 
            key={index} 
            title={projects.title}
            github={projects.github} 
            text={projects.text} 
            imageUrl={projects.imageUrl} 
            className="custom-card"
          />
        ))}
      </div>
    </div>
  );
};

export default TopProject;
